export default "__VITE_ASSET__PiAEXNi7__"